"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductionDashboardSearchResponse = void 0;
const common_1 = require("../../../common");
const production_dashboard_data_response_1 = require("./production-dashboard-data.response");
class ProductionDashboardSearchResponse extends common_1.PaginatedResponse {
}
exports.ProductionDashboardSearchResponse = ProductionDashboardSearchResponse;
//# sourceMappingURL=production-dashboard-search.response.js.map